module.exports = __webpack_public_path__ + "img/faq-closed.97f80aa4.svg";